<template>
  <div id="question-change-dialog">
    <el-dialog
      title="试题替换"
      :close-on-click-modal="false"
      :visible="exerciseChange"
      :width="`${dialogWidth}px`"
      center
      custom-class="dialog-commoon-style exercise-change-dialog"
      @close="exerciseChange = false"
    >
      <div v-if="exerciseChangeInfo.data && exerciseChangeInfo.data.length > 0" class="scrollbar">
        <div class="exercise-change-toolbar">
          <ul>
            <li
              v-for="(item, index) in exerciseChangeInfo.data"
              :key="item.id"
              :class="index == changeIndex ? 'active' : ''"
              @click="selectChange(index)"
            >
              {{ index + 1 }}
            </li>
          </ul>
          <el-button size="mini" icon="el-icon-refresh" @click="replaceOthers">换一批</el-button>
        </div>
        <div @click="showAnalyize">
          <div class="exercise-change-question" v-html="singleChangeInfo.title"></div>
        </div>
        <div
          id="exercise-change-options"
          class="exercise-change-options"
          @click="showAnalyize"
          v-if="singleChangeInfo.options && singleChangeInfo.options.length > 0"
        >
          <div v-for="(opt, order) in singleChangeInfo.options" :key="order">
            <div
              v-for="(value, key) in opt"
              :key="key"
              :style="{
                width: singleChangeInfo.w_arr ? singleChangeInfo.w_arr[order].width + 'px' : '',
                paddingLeft:
                  singleChangeInfo.type_id == 7 && singleChangeInfo.w_arr && singleChangeInfo.w_arr[order].row == 2 && key == 'C' ? '60px' : '',
              }"
            >
              <span v-if="singleChangeInfo.type_id == 7 && key == 'A'">({{ order + 1 }}).</span>
              <span
                :class="singleChangeInfo.type_id == 7 && key == 'A' ? 'spacer' : ''"
                :style="{
                  left: singleChangeInfo.type_id == 7 && singleChangeInfo.w_arr && singleChangeInfo.w_arr[order].row == 2 && key == 'C' ? '40px' : '',
                }"
                >{{ key }}.</span
              >
              <span v-html="value"></span>
            </div>
          </div>
        </div>
        <div class="audio-wrap" v-if="singleChangeInfo.file">
          <audio controls>
            <source :src="singleChangeInfo.file" />
          </audio>
        </div>
        <ol
          class="exercise-change-subquestion"
          v-if="singleChangeInfo.sub_questions && singleChangeInfo.sub_questions.length > 0"
          @click="showAnalyize"
        >
          <li v-for="(subQuestion, index) in singleChangeInfo.sub_questions" :key="subQuestion.id">
            <span>({{ subQuestion.sort }})</span>
            <div class="exercise-change-subquestion-title" v-html="subQuestion.title"></div>
            <!-- 子题选项 -->
            <div class="exercise-change-subquestion-title-options" v-for="subOption in subQuestion.options" :key="subOption.index">
              <div v-for="(value, key) in subOption" :key="key" :style="{ width: subQuestion.sub_width + 'px' }">
                <span>{{ key }}.</span>
                <span v-html="value"></span>
              </div>
            </div>
            <div class="exercise-change-subquestion-answer" v-if="exerciseAnswer" v-show="singleChangeInfo.isShow">
              <span class="exercise-change-subquestion-answer-left">【答案】</span>
              <template v-if="exerciseAnswer.type == 'image'">
                <p class="exercise-change-subquestion-answer-right">
                  <img :src="exerciseAnswer.answerImg[index]" />
                </p>
              </template>
              <template v-else>
                <p
                  class="exercise-change-subquestion-answer-right"
                  v-html="exerciseAnswer.answer[index] ? exerciseAnswer.answer[index] : '暂无内容'"
                ></p>
              </template>
            </div>
          </li>
        </ol>
        <div class="exercise-change-answer" v-show="singleChangeInfo.isShow">
          <div class="exercise-analyize" v-if="exerciseAnswer">
            <div class="exercise-analyize-item" v-if="singleChangeInfo.sub_questions && singleChangeInfo.sub_questions.length == 0">
              <span class="exercise-analyize-left">【答案】</span>
              <template v-if="exerciseAnswer.type == 'image'">
                <div class="exercise-analyize-right">
                  <img :src="exerciseAnswer.answerImg" />
                </div>
              </template>
              <template v-else>
                <div class="exercise-analyize-right" v-html="exerciseAnswer.answer[0] ? exerciseAnswer.answer[0] : '暂无内容'"></div>
              </template>
            </div>
            <div class="exercise-analyize-item">
              <span class="exercise-analyize-left">【考点】</span>
              <div class="exercise-analyize-right" v-html="exerciseAnswer.centre ? exerciseAnswer.centre : '暂无内容'"></div>
            </div>
            <div class="exercise-analyize-item">
              <span class="exercise-analyize-left">【解析】</span>
              <div v-if="exerciseAnswer.status == 0">
                <template v-if="exerciseAnswer.type == 'image'">
                  <div class="exercise-analyize-right">
                    <img :src="exerciseAnswer.analysisImg" />
                  </div>
                </template>
                <template v-else>
                  <div class="exercise-analyize-right" v-html="exerciseAnswer.analysis ? exerciseAnswer.analysis : '暂无内容'"></div>
                </template>
              </div>
              <div v-else class="exercise-no-analyize">
                <p><i class="iconfont icon-tixing2"></i><span v-html="exerciseAnswer.analysis"></span></p>
              </div>
            </div>
          </div>
          <div v-show="exerciseAnswer" v-else>暂无内容</div>
        </div>
      </div>
      <div v-else class="exercise-empty">
        <p>
          <i class="iconfont icon-wushuju"></i><br />
          暂无可替换试题
        </p>
      </div>
      <div slot="footer">
        <div class="exercise-change-message" v-if="exerciseChangeInfo.data && exerciseChangeInfo.data.length > 0">
          <div class="exercise-change-message-attr">
            <span class="exercise-change-message-span1">{{ singleChangeInfo.type_name }}</span>
            <em>|</em> <span>{{ singleChangeInfo.class_name }}</span> <em>|</em> <span>{{ singleChangeInfo.difficult }}</span> <em>|</em>
            <span
              >组卷<em> {{ singleChangeInfo.used_num }} </em>次</span
            >
            <em v-if="singleChangeInfo.source">|</em>
            <span class="exercise-change-message-span2" v-if="singleChangeInfo.source">
              来源：
              <a :href="singleChangeInfo.source_link">{{ singleChangeInfo.source }}</a>
            </span>
          </div>
          <div class="exercise-change-message-handle">
            <a :href="singleChangeInfo.question_link" target="_blank"><i class="iconfont icon-xiangqing"></i>查看解析</a>
            <a href="javascript:;" @click="toggleDialogCollect"
              ><i class="iconfont icon-favourite" :class="singleChangeInfo.collect == 1 ? 'icon-shoucang0' : 'icon-favourite'"></i>收藏</a
            >
          </div>
        </div>
        <el-button type="primary" size="small" @click="exerciseChangeComfirm" v-if="exerciseChangeInfo.data && exerciseChangeInfo.data.length > 0"
          >换 题</el-button
        >
        <el-button size="small" @click="exerciseChange = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
var that
import { mapGetters } from 'vuex'
import { paperReplace, paperReplaceComfirm } from '@/api/paperEdit'
import { paperAnswer, questionCollect } from '@/api/manual.js'
import * as util from '../utils/util.js'
export default {
  name: 'questionChange',
  props: ['paperId'],
  data() {
    return {
      dialogWidth: 840,
      exerciseChange: false,
      qid: null,
      qpage: 1,
      exerciseChangeInfo: '', // 换题总数据
      singleChangeInfo: '', // 单条数据
      exerciseAnswer: null, // 答案解析
      changeIndex: 0,
      optsParentWidth: '', // 选项父级容器宽度
    }
  },
  computed: {
    ...mapGetters(['baseLink', 'userInfo']),
  },
  created() {
    that = this
  },
  mounted() {
    that.$nextTick(() => {
      that.optsParentWidth = that.dialogWidth - 40
    })
  },
  watch: {
    exerciseChange(val) {
      // 关闭时清楚答案解析
      if (!val) {
        that.exerciseAnswer = null
      }
    },
  },
  methods: {
    /*********************************** 试题替换弹窗 *******************************************/
    showChangedialog(id) {
      // 打开换题弹窗
      that.qid = id
      that.changeIndex = 0
      that.qpage = 1
      that.getPaperReplaceList(id)
    },
    async toggleDialogCollect() {
      // 收藏,取消收藏
      let data = {
        id: that.singleChangeInfo.id,
      }
      let res = await questionCollect(data)
      if (res.code == 200) {
        let flag = ''
        if (that.singleChangeInfo.collect == 0) {
          util.showTips('收藏成功')
          flag = 1
        } else {
          util.showTips('取消收藏')
          flag = 0
        }
        that.$set(that.singleChangeInfo, 'collect', flag)
      }
    },
    selectChange(i) {
      // 切换选题
      that.changeIndex = i
      that.exerciseAnswer = null
      that.singleChangeInfo = that.exerciseChangeInfo.data[i]
      that.$set(that.singleChangeInfo, 'isShow', false)
    },
    replaceOthers() {
      // 换一批
      that.changeIndex = 0
      that.exerciseAnswer = null
      that.qpage++
      if (that.qpage > that.exerciseChangeInfo.last_page) {
        that.qpage = 1
      }
      that.getPaperReplaceList(that.qid)
    },
    showAnalyize() {
      // 查看更多
      if (!that.exerciseAnswer) {
        that.getPaperAnswer(that.singleChangeInfo.id)
      } else {
        that.$set(that.singleChangeInfo, 'isShow', !that.singleChangeInfo.isShow)
      }
    },
    async getPaperAnswer(id) {
      // 获取试题详情
      let data = {
        question_id: id,
      }
      let res = await paperAnswer(data)
      if (res.code === 200) {
        that.exerciseAnswer = res.data
        that.$set(that.singleChangeInfo, 'isShow', !that.singleChangeInfo.isShow)
      }
    },
    async exerciseChangeComfirm() {
      // 确定换题
      let curObj = that.exerciseChangeInfo.data[that.changeIndex]
      let data = {
        paper_id: that.paperId,
        question_id: that.qid,
        replace_question_id: curObj.question_id,
      }
      let res = await paperReplaceComfirm(data)
      if (res.code === 200) {
        that.$emit('reloadPaper', true)
        that.exerciseChange = false
      }
    },
    async getPaperReplaceList(id) {
      // 获取换题列表
      let data = {
        paper_id: that.paperId,
        question_id: id,
        page: that.qpage,
      }
      let res = await paperReplace(data)
      if (res.code === 200) {
        that.exerciseChange = true
        that.exerciseChangeInfo = res.data
        if (that.exerciseChangeInfo.data.length > 0) {
          // 设置选项宽度
          util.getOptionsWidth(that.exerciseChangeInfo.data, that.optsParentWidth, that)
          that.singleChangeInfo = that.exerciseChangeInfo.data[0] // 默认显示第一条
          that.$set(that.singleChangeInfo, 'isShow', false) // 查看更多
        }
      }
    },
  },
}
</script>
<style lang="scss">
#question-change-dialog {
  .exercise-change-dialog {
    width: 100%;
    .audio-wrap {
      cursor: pointer;
      padding: 0 20px;
      margin-bottom: 10px;
      audio {
        outline: none;
      }
    }
    & > .el-dialog__body > div {
      position: relative;
      overflow: hidden;
      min-height: 300px;
      padding-bottom: 70px;
    }

    & > .el-dialog__footer {
      position: relative;
    }

    .exercise-empty {
      & > p {
        width: 100%;
        padding: 100px 0 150px;
        text-align: center;
        font-size: 14px;
        color: #ccc;
        line-height: 30px;

        & > i {
          font-size: 70px;
        }
      }
    }

    .exercise-change-toolbar {
      box-sizing: border-box;
      width: 100%;
      padding: 20px 20px 0;
      overflow: hidden;

      & > .el-button {
        float: left;
        margin-left: 40px;
        font-size: 14px;
      }

      & > ul {
        overflow: hidden;
        float: left;

        & > li {
          box-sizing: border-box;
          float: left;
          width: 34px;
          height: 30px;
          line-height: 30px;
          border-radius: 2px;
          color: #909090;
          text-align: center;
          border: 1px solid #f2f2f2;
          margin-right: 15px;
          cursor: pointer;

          &:hover,
          &.active {
            color: #fff;
            background-color: #2b99ff;
            border-color: #2b99ff;
          }
        }
      }
    }

    .exercise-change-question {
      box-sizing: border-box;
      padding: 15px 20px 10px 20px;
      line-height: 24px;
      font-size: 14px;
      color: #333;
      cursor: pointer;
    }

    .exercise-change-options {
      box-sizing: border-box;
      overflow: hidden;
      width: 100%;
      padding: 0 20px;
      cursor: pointer;

      & > div {
        overflow: hidden;
        padding-bottom: 5px;
        width: 800px;
        div {
          color: #666;
          font-size: 14px;
          position: relative;
          float: left;
          line-height: 26px;
          vertical-align: top;
          padding: 0 20px;
          box-sizing: border-box;
          & > span {
            display: inline-block;
            &:nth-child(1) {
              position: absolute;
              top: 0;
              left: 0;
            }
            &.spacer + span {
              vertical-align: middle;
              white-space: nowrap;
            }
          }
        }
      }
    }

    .exercise-change-subquestion {
      color: #333;
      font-size: 14px;
      line-height: 20px;
      padding: 10px 20px 0;
      cursor: pointer;
      & > li {
        overflow: hidden;
        & > span {
          float: left;
          padding-right: 7px;
        }
        .exercise-change-subquestion-title {
          margin-bottom: 10px;
        }
        & > .exercise-change-subquestion-title-options {
          overflow: hidden;
          margin: 10px 0;
          width: 800px;
          & > div {
            color: #666;
            font-size: 14px;
            position: relative;
            float: left;
            vertical-align: top;
            padding: 0 20px;
            box-sizing: border-box;
            & > span:nth-child(1) {
              position: absolute;
              top: 0;
              left: 0;
            }
          }
        }
        .exercise-change-subquestion-answer {
          overflow: hidden;
          margin-bottom: 10px;
          .exercise-change-subquestion-answer-left {
            float: left;
            height: 24px;
            line-height: 24px;
            border-radius: 2px;
            color: #2b99ff;
            text-align: center;
            font-size: 14px;
            margin-left: -7px;
          }
          .exercise-change-subquestion-answer-right {
            margin-left: 60px;
            color: #333;
            & > img {
              width: 100%;
            }
          }
        }
      }
    }

    .exercise-change-answer {
      box-sizing: border-box;
      overflow: hidden;
      padding-top: 20px;
      margin: 0 20px;
      border-top: 1px dashed #f2f2f2;

      .exercise-analyize-item {
        padding-bottom: 20px;
        line-height: 24px;
        color: #333;
        font-size: 14px;
        overflow: hidden;

        .exercise-no-analyize {
          & > p {
            padding-left: 60px;
            color: #ff6600;

            & > i {
              padding-right: 10px;
            }
          }
        }

        .exercise-analyize-left {
          float: left;
          height: 24px;
          line-height: 24px;
          border-radius: 2px;
          color: #2b99ff;
          text-align: center;
          font-size: 14px;
          margin-left: -7px;
        }

        .exercise-analyize-right {
          margin-left: 60px;
          color: #333;
          & > img {
            width: 100%;
          }
        }
      }
    }

    .exercise-change-message {
      position: absolute;
      top: -50px;
      left: 0;
      overflow: hidden;
      width: 100%;
      padding: 0 20px;
      background-color: #fff;
      box-sizing: border-box;
      font-size: 12px;
      color: #999;
      margin-top: -1px;
      border-top: 1px solid #f2f2f2;
      border-bottom: 1px solid #ccc;

      .exercise-change-message-attr {
        float: left;
        display: flex;
        align-items: center;
        & > span {
          line-height: 50px;
          color: #666;

          & > em {
            color: #2b99ff;
          }
        }

        & > .exercise-change-message-span1 {
          display: inline-block;
          padding: 0 5px;
          height: 18px;
          line-height: 18px;
          color: #2b99ff;
          border: 1px solid #2b99ff;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 80px;
        }

        & > .exercise-change-message-span2 {
          display: inline-block;
          width: 200px;
          line-height: 18px;
          height: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          & > a:hover {
            color: #2b99ff;
          }
        }

        & > em {
          margin: 0 14px;
          line-height: 50px;
          color: #ddd;
          font-style: normal;
        }
      }

      .exercise-change-message-handle {
        float: right;

        & > a {
          float: left;
          margin-top: 10px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: #2b99ff;

          &:nth-child(1) {
            margin-right: 20px;
          }

          & > i {
            padding-right: 5px;
          }
        }
      }
    }
  }
}
</style>

<style>
.exercise-no-analyize .jumpUrl {
  color: #2b99ff;
}
</style>
